<script>
import layout from '@src/mixins/layout.vue'
import { RingLoader } from '@saeris/vue-spinners'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import { chatComputed } from '@/src/state/chatHelper'
import { providerChatService } from '@/src/services/safehaven/ProviderChatService'

export default {
  components: {
    RingLoader,
  },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      dialog: true,
      queueNumber: null,
      timer: '',
    }
  },
  computed: {
    ...chatComputed,
    providerResponseStatus() {
      if (
        this.chatDialog &&
        this.chatDialog.component === 'Wait' &&
        this.providerResponse
      ) {
        return true
      }
      return false
    },
  },
  watch: {
    chatDetails(newValue) {
      this.queueNumber = Number(newValue.Position)
    },
  },
  created() {
    providerChatService.connect()
  },
  methods: {
    stopTimer() {
      clearTimeout(this.timer)
      return this.navigateToScreen('safehaven-health-help')
    },
  },
}
</script>

<template>
  <v-row justify="center">
    <v-card-text :class="$style.chatContainer" class="text-center">
      <div v-if="providerResponseStatus">
        <div>
          <RingLoader
            :class="$style.loaderContainer"
            color="#7EB3E7"
            :size="100"
          />
        </div>

        <div :class="$style.queueTextContainer">
          <p :class="$style.queueText">
            Your secure chat session will begin soon.
          </p>
          <p :class="$style.queueText">You are in queue </p>
          <p v-if="queueNumber !== null" :class="$style.queueNumberText">{{
            $store.state.chat.chatDetails.Position
          }}</p>
          <h6 v-else align="center">loading...</h6>
        </div>
      </div>

      <div v-else :class="$style.noResponseTextContainer">
        <p :class="$style.queueText">
          We’re sorry, a provider is not able to respond at the moment.
        </p>
        <p :class="$style.queueText">Please try again later. </p>
      </div>
    </v-card-text>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';

.dialogMenu {
  border-radius: 9px !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.dialogContainer {
  height: 600px;
  background-color: #f2f9ff !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.endSecureChatText {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  color: #0476d9;
  text-align: right;
  letter-spacing: 0;
}

.chatContainer {
  height: 300px;
  margin-top: 20%;
}

.loaderContainer {
  margin: 0 auto;
}

.queueTextContainer {
  margin-top: 20px;
}

.noResponseTextContainer {
  margin-top: 100px;
}

.queueText {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0;
}

.queueNumberText {
  font-size: 60px;
  font-weight: 400;
  line-height: 90px;
  text-align: center;
  letter-spacing: 0;
}
</style>
